import { INITIAL_PEER_STATS } from '../services/video-room/video-room.types';

import { PeerStats } from './types';

export const formatPeerStats = (stats: RTCStatsReport, _peerStats?: PeerStats): PeerStats => {
  const peerStats = _peerStats ?? { ...INITIAL_PEER_STATS };
  stats.forEach((value) => {
    peerStats.timestamp = value.timestamp;
    // Inbound
    if (value.type === 'inbound-rtp' && typeof value.kind != 'undefined') {
      peerStats.packetsReceived = value.packetsReceived ?? 0;
      peerStats.bytesReceived = value.bytesReceived ?? 0;
      peerStats.packetsLost = value.packetsLost ?? 0;

      if (value.kind === 'audio') {
        peerStats.audioJitter = value.jitter ?? 0;
        peerStats.audioJitterBufferDelay = value.jitterBufferDelay ?? 0;
        peerStats.audioPacketsLost += value.packetsLost ?? 0;
      }
      if (value.kind === 'video') {
        peerStats.videoJitter = value.jitter ?? 0;
        peerStats.videoJitterBufferDelay = value.jitterBufferDelay ?? 0;
        peerStats.videoPacketsLost = value.packetsLost ?? 0;
        peerStats.framesReceived = value.framesReceived ?? 0;
        peerStats.framesPerSecond = value.framesPerSecond ?? 0;
        peerStats.frameHeight = value.frameHeight ?? 0;
        peerStats.frameWidth = value.frameWidth ?? 0;
        peerStats.framesDropped = value.framesDropped ?? 0;
      }
    }
    // Outbound
    if (value.type === 'outbound-rtp' && typeof value.kind != 'undefined') {
      peerStats.packetsSent = value.packetsSent ?? 0;
      peerStats.bytesSent = value.bytesSent ?? 0;
      if (value.kind === 'video') {
        peerStats.firCount = value.firCount ?? 0;
        peerStats.frameHeight = value.frameHeight ?? 0;
        peerStats.framesEncoded = value.framesEncoded ?? 0;
        peerStats.framesPerSecond = value.framesPerSecond ?? 0;
        peerStats.framesSent = value.framesSent ?? 0;
        peerStats.frameWidth = value.frameWidth ?? 0;
        peerStats.keyFramesEncoded = value.keyFramesEncoded ?? 0;
        peerStats.mediaSourceId = value.mediaSourceId ?? 'unknown';
        peerStats.nackCount = value.nackCount ?? 0;
        peerStats.outboundQLR = value.qualityLimitationReason ?? 'unknown';
        peerStats.pliCount = value.pliCount ?? 0;
        peerStats.targetBitrate = value.targetBitrate ?? 0;
        if (value.qualityLimitationDurations) {
          Object.keys(value.qualityLimitationDurations).forEach((key) => {
            if (key.toString() === peerStats.outboundQLR) {
              peerStats.limitationDuration = value.qualityLimitationDurations[key];
            }
          });
        }
      }
    }
  });
  return peerStats;
};
